
export const salesStageChartOptions = {
  plugins: {
    legend: {
      position: "bottom"
    },
    datalabels: {
      color: "#000"
    }
  },
  scales: {
    x: {
      padding: 5
    }
  },
  maintainAspectRatio: false
};
